module.exports = __webpack_public_path__ + "static/security2@2x-200e161ed791b97fcd2207e99eb23806.png";